import { useEffect } from 'react';
import { type ecommerceEvents } from '@bedrock/analytics/events';
import { type AnalyticsObject } from '@bedrock/analytics/types';

enum OpenTableEvent {
  OpenModal = 'OT_OPEN_MODAL',
  AppReady = 'APP_READY',
}

type OpenTableBaseEvent<E extends OpenTableEvent> = {
  type: E;
  uuid: string;
};

type OpenTableReadyEventData = OpenTableBaseEvent<OpenTableEvent.AppReady>;

type OpenTableEventData = OpenTableReadyEventData | string | null;

export const useOpenTableAnalytics = (analytics: AnalyticsObject<typeof ecommerceEvents>) => {
  useEffect(() => {
    const handler = (event: MessageEvent<OpenTableEventData>) => {
      if (event.origin !== 'https://www.opentable.com') return;
      if (!(event.data && typeof event.data === 'object' && 'type' in event.data)) return;

      console.info('OpenTable event data:', event.data);
    };

    globalThis.addEventListener('message', handler);
    return () => {
      globalThis.removeEventListener('message', handler);
    };
  }, [analytics]);
};
